module.exports = __webpack_public_path__ + "static/scopriabitareco_experiences_virtualphotography-e57f118ac3d78de5d5bae5f85e6cdd3d.jpg";